import * as React from 'react';
import { LegalCheck } from '@cian/ui-kit';
import { useDeviceType } from '@cian/ui-kit/responsive/hooks/useDeviceType';
import clsx from 'clsx';

import * as styles from './styles.css';

interface IAgreementsBlockProps {
  isChecked?: boolean;
  toggleCheckbox(): void;
  privacyPolicyUrl: string;
  personalDataAgreement: string;
  marketingAgreementUrl?: string;
}

export const AgreementsBlock: React.FC<React.PropsWithChildren<IAgreementsBlockProps>> = ({
  isChecked,
  toggleCheckbox,
  privacyPolicyUrl,
  personalDataAgreement,
  marketingAgreementUrl,
}) => {
  const deviceType = useDeviceType();

  return (
    <div className={clsx(styles['legal'], styles[deviceType])}>
      <LegalCheck
        privacyPolicyUrl={privacyPolicyUrl}
        personalDataUrl={personalDataAgreement}
        marketingAgreementUrl={marketingAgreementUrl}
        checked={isChecked}
        onCheckedChange={toggleCheckbox}
        dataTestId={'marketing_agreement'}
      />
    </div>
  );
};

AgreementsBlock.displayName = 'AgreementsBlock';
